import { t } from 'i18next';

interface IAuthErrorMessages {
  [key: string]: string;
}

// function to get the authentication API errors with loaded transaltion messages
// these error codes defined on Firebase authentication Docs, visit: https://firebase.google.com/docs/auth/admin/errors
const getAuthenticationAPIErrors = (): IAuthErrorMessages => ({
  'auth/claims-too-large': t('apiAuthenticationErrors.claimsTooLarge'),
  'auth/email-already-exists': t('apiAuthenticationErrors.emailAlreadyExists'),
  'auth/id-token-expired': t('apiAuthenticationErrors.idTokenExpired'),
  'auth/id-token-revoked': t('apiAuthenticationErrors.idTokenRevoked'),
  'auth/insufficient-permission': t('apiAuthenticationErrors.insufficientPermission'),
  'auth/internal-error': t('apiAuthenticationErrors.internalError'),
  'auth/invalid-argument': t('apiAuthenticationErrors.invalidArgument'),
  'auth/invalid-claims': t('apiAuthenticationErrors.invalidClaims'),
  'auth/invalid-continue-uri': t('apiAuthenticationErrors.invalidContinueUri'),
  'auth/invalid-creation-time': t('apiAuthenticationErrors.invalidCreationTime'),
  'auth/invalid-credential': t('apiAuthenticationErrors.invalidCredential'),
  'auth/invalid-disabled-field': t('apiAuthenticationErrors.invalidDisabledField'),
  'auth/invalid-display-name': t('apiAuthenticationErrors.invalidDisplayName'),
  'auth/invalid-dynamic-link-domain': t('apiAuthenticationErrors.invalidDynamicLinkDomain'),
  'auth/invalid-email': t('apiAuthenticationErrors.invalidEmail'),
  'auth/invalid-email-verified': t('apiAuthenticationErrors.invalidEmailVerified'),
  'auth/invalid-hash-algorithm': t('apiAuthenticationErrors.invalidHashAlgorithm'),
  'auth/invalid-hash-block-size': t('apiAuthenticationErrors.invalidHashBlockSize'),
  'auth/invalid-hash-derived-key-length': t('apiAuthenticationErrors.invalidHashDerivedKeyLength'),
  'auth/invalid-hash-key': t('apiAuthenticationErrors.invalidHashKey'),
  'auth/invalid-hash-memory-cost': t('apiAuthenticationErrors.invalidHashMemoryCost'),
  'auth/invalid-hash-parallelization': t('apiAuthenticationErrors.invalidHashParallelization'),
  'auth/invalid-hash-rounds': t('apiAuthenticationErrors.invalidHashRounds'),
  'auth/invalid-hash-salt-separator': t('apiAuthenticationErrors.invalidHashSaltSeparator'),
  'auth/invalid-id-token': t('apiAuthenticationErrors.invalidIdToken'),
  'auth/invalid-last-sign-in-time': t('apiAuthenticationErrors.invalidLastSignInTime'),
  'auth/invalid-page-token': t('apiAuthenticationErrors.invalidPageToken'),
  'auth/invalid-password': t('apiAuthenticationErrors.invalidPassword'),
  'auth/invalid-password-hash': t('apiAuthenticationErrors.invalidPasswordHash'),
  'auth/invalid-password-salt': t('apiAuthenticationErrors.invalidPasswordSalt'),
  'auth/invalid-phone-number': t('apiAuthenticationErrors.invalidPhoneNumber'),
  'auth/invalid-photo-url': t('apiAuthenticationErrors.invalidPhotoUrl'),
  'auth/invalid-provider-data': t('apiAuthenticationErrors.invalidProviderData'),
  'auth/invalid-provider-id': t('apiAuthenticationErrors.invalidProviderId'),
  'auth/invalid-oauth-responsetype': t('apiAuthenticationErrors.invalidOauthResponseType'),
  'auth/invalid-session-cookie-duration': t('apiAuthenticationErrors.invalidSessionCookieDuration'),
  'auth/invalid-uid': t('apiAuthenticationErrors.invalidUid'),
  'auth/invalid-user-import': t('apiAuthenticationErrors.invalidUserImport'),
  'auth/maximum-user-count-exceeded': t('apiAuthenticationErrors.maximumUserCountExceeded'),
  'auth/missing-android-pkg-name': t('apiAuthenticationErrors.missingAndroidPkgName'),
  'auth/missing-continue-uri': t('apiAuthenticationErrors.missingContinueUri'),
  'auth/missing-hash-algorithm': t('apiAuthenticationErrors.missingHashAlgorithm'),
  'auth/missing-ios-bundle-id': t('apiAuthenticationErrors.missingIosBundleId'),
  'auth/missing-uid': t('apiAuthenticationErrors.missingUid'),
  'auth/missing-oauth-client-secret': t('apiAuthenticationErrors.missingOauthClientSecret'),
  'auth/operation-not-allowed': t('apiAuthenticationErrors.operationNotAllowed'),
  'auth/phone-number-already-exists': t('apiAuthenticationErrors.phoneNumberAlreadyExists'),
  'auth/project-not-found': t('apiAuthenticationErrors.projectNotFound'),
  'auth/reserved-claims': t('apiAuthenticationErrors.reservedClaims'),
  'auth/session-cookie-expired': t('apiAuthenticationErrors.sessionCookieExpired'),
  'auth/session-cookie-revoked': t('apiAuthenticationErrors.sessionCookieRevoked'),
  'auth/too-many-requests': t('apiAuthenticationErrors.tooManyRequests'),
  'auth/uid-already-exists': t('apiAuthenticationErrors.uidAlreadyExists'),
  'auth/unauthorized-continue-uri': t('apiAuthenticationErrors.unauthorizedContinueUri'),
  'auth/user-not-found': t('apiAuthenticationErrors.userNotFound'),
  'auth/user-disabled': t('apiAuthenticationErrors.userDisabled'),
  'auth/unauthorized-domain': t('apiAuthenticationErrors.unauthorizedDomain'),
  'auth/default': t('apiAuthenticationErrors.default'),
});

export default getAuthenticationAPIErrors;
